export const LANDING_PAGES = {
  privacyPolicy: 'https://technologymatch.com/privacy-policy',
  termsAndConditions: 'https://technologymatch.com/terms-and-conditions',
  disclaimer: 'https://technologymatch.com/disclaimer',
} as const
